export default {"src":"/_next/static/media/seemore.dc1e6eb3.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};